import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { LiquidacionService } from 'src/app/services/liquidacion/liquidacion.service';
import { guardarArchivo } from 'src/app/utils/descargar';
import { conceptosDeCargos, cuentaConDesglose, tasa } from './desglose-cobranza';

/**
 * DETALLE DE UNA LIQUIDACIÓN DE COBRANZA (6.5). Lo abre el tesorero en el cierre y quien firma en Por aprobar: la cuenta
 * de lo aplicado a lo que se paga, los cinco controles (reemplazan «cuadra con los pagarés»), las ventas del día de mayor
 * monto y el Excel de auditoría con todo (Resumen, Ventas, Abonos, Retenidos, Reversos y Controles).
 */
@Component({
  selector: 'app-liquidacion-cobranza',
  templateUrl: './liquidacion-cobranza.component.html'
})
export class LiquidacionCobranzaComponent implements OnChanges, OnDestroy {
  @Input() dia = '';
  @Input() comercio = '';
  /** El corte de esa liquidación: el mismo comercio puede tener una por corte en el día. */
  @Input() corte: number | null = null;

  cargando = false;
  error = '';
  d: any = null;
  /** DSG: la cuenta con la tasa de la comisión y un renglón por cargo, y los conceptos de la columna «Cargos». */
  cuenta: any[] = [];
  conceptos = '';
  tasa = tasa;
  // LQV-03: la tabla de abonos se pagina en el servidor
  opcionesPor = [50, 100, 200];
  por = 50;
  pagina = 1;
  buscar = '';
  cargandoAbonos = false;
  private espera: any = null;

  constructor(private liq: LiquidacionService) { }

  ngOnChanges(): void { this.pagina = 1; this.cargar(); }
  ngOnDestroy(): void { clearTimeout(this.espera); }

  cargar = async (): Promise<void> => {
    if (!this.dia || !this.comercio) return;
    this.cargando = true; this.error = '';
    try {
      this.d = await this.liq.cobranzaDetalle(this.dia, this.comercio, this.pagina, this.por, this.buscar, this.corte);
      this.cuenta = cuentaConDesglose(this.d && this.d.cuenta, this.d && this.d.totales);
      this.conceptos = conceptosDeCargos(this.d && this.d.totales);
    }
    catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer el detalle de la cobranza.'; }
    finally { this.cargando = false; }
  };

  /** LQV-03: solo se vuelve a pedir la página de abonos; la cuenta y los controles se quedan como estaban. */
  irAPagina = async (pagina: number): Promise<void> => {
    const a = this.d && this.d.abonos;
    if (!a || pagina < 1 || (pagina > 1 && pagina > (a.paginas || 1)) || this.cargandoAbonos) return;
    this.cargandoAbonos = true; this.error = '';
    try {
      const r = await this.liq.cobranzaDetalle(this.dia, this.comercio, pagina, this.por, this.buscar, this.corte);
      // datos viejos del núcleo (sin d.abonos): se deja la tabla como estaba
      if (r && r.abonos) { this.d = { ...this.d, abonos: r.abonos }; this.pagina = r.abonos.pagina || pagina; }
    } catch (e: any) { this.error = e?.error?.msg || 'No se pudo leer esa página de abonos.'; }
    finally { this.cargandoAbonos = false; }
  };

  /** Cambia el tamaño de la página: vuelve a la primera. */
  cambiarPor = (por: any): void => { this.por = Number(por) || 50; this.pagina = 1; this.irAPagina(1); };

  /** LQV-03: la búsqueda (cédula, crédito o referencia) espera 300 ms sin teclear y vuelve a la página 1. */
  buscarCambia = (texto: string): void => {
    this.buscar = (texto || '').trim();
    clearTimeout(this.espera);
    this.espera = setTimeout(() => { this.pagina = 1; this.irAPagina(1); }, 300);
  };

  /** Las filas de un mismo pago van juntas: el pago se muestra solo en la primera de cada grupo (COB-18). */
  primeraDelPago(filas: any[], i: number): boolean {
    if (i === 0) return true;
    const a = filas[i], b = filas[i - 1];
    if (!a.pago_referencia) return true;
    return a.pago_referencia !== b.pago_referencia || a.pago_banco !== b.pago_banco || a.pago_monto !== b.pago_monto;
  }

  descargar = async (): Promise<void> => {
    try { guardarArchivo(await this.liq.cobranzaExcel(this.dia, this.comercio), `cobranza-${this.comercio}-${this.dia}.xlsx`); }
    catch (e: any) { this.error = 'No se pudo descargar el Excel de cobranza.'; }
  };
}
